export default __webpack_public_path__ + "static/media/new_dashboard_assessment_icon.27bba960.svg";